import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonAtomComponent, ButtonIconAtomComponent } from '../../atoms';

@Component({
  selector: 'ls-cancel-save-molecule',
  standalone: true,
  imports: [
    CommonModule,
    ButtonIconAtomComponent,
    ButtonAtomComponent
  ],
  templateUrl: './cancel-save-molecule.component.html',
  styleUrl: './cancel-save-molecule.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelSaveMoleculeComponent {

  @Input() labelCancel = 'Cancel';
  @Input() labelSave = 'Guardar';
  @Input() processing = false;

  @Output() saveClick = new EventEmitter<Event>();
  @Output() cancelClick = new EventEmitter<Event>();

  handleCancelClick(event: Event) {
    this.cancelClick.emit(event);
  }

  handleSaveClick(event: Event) {
    this.saveClick.emit(event);
  }
}
